export default __webpack_public_path__ + "static/media/G0480.34I-40928_-24259_0.1654023300000.0058bd78.jpg";